import {
  INIT_REDUCER,
  CLEAR_ERRORS,
  CREATE_ERRORS,
  GET_PRMS_REQUEST,
  DELETE_PRM_REQUEST,
} from './types';

const deletePRM = (payload) => ({
  type: DELETE_PRM_REQUEST,
  payload,
});

const getPRMs = (payload) => ({
  type: GET_PRMS_REQUEST,
  payload,
});

const initReducer = () => ({
  type: INIT_REDUCER,
});

const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

const createErrors = (payload) => ({
  type: CREATE_ERRORS,
  payload: payload,
});

export { getPRMs, initReducer, clearErrors, createErrors, deletePRM };
